<script>
    import DefaultLayout from '../components/layouts/DefaultLayout/DefaultLayout';

    export default {
        extends: DefaultLayout,
    };
</script>
